import { __extends } from 'tslib';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames, liveAnnounce } from 'uitk-react-utils';
import { UitkActionListItem } from 'uitk-react-action-list-item';
import { UitkButton } from 'uitk-react-button';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import styles from './uitk-typeahead.css';

var getClassNameList = classNames.bind(styles);
var UitkTypeaheadResultItem = /** @class */ (function (_super) {
    __extends(UitkTypeaheadResultItem, _super);
    function UitkTypeaheadResultItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    UitkTypeaheadResultItem.prototype.handleClick = function () {
        var _a = this.props, data = _a.data, onResultItemSelect = _a.onResultItemSelect, value = _a.value;
        onResultItemSelect(value, data);
    };
    UitkTypeaheadResultItem.prototype.render = function () {
        var _a = this.props, activeSuggestion = _a.activeSuggestion, className = _a.className, icon = _a.icon, index = _a.index, name = _a.name, stid = _a.stid, sanitized = _a.sanitized, subtext = _a.subtext, contentRef = _a.contentRef, historyDetail = _a.historyDetail;
        var cssClassNames = getClassNameList(className, subtext ? 'uitk-typeahead-result-item has-subtext' : 'uitk-typeahead-result-item', activeSuggestion === true && 'uitk-typeahead-result-item-hover');
        if (activeSuggestion === true) {
            var sanitizedName = name.replace(/(<([^>]+)>)/gi, '');
            liveAnnounce("".concat(sanitizedName), undefined, undefined, contentRef);
        }
        var ariaLabel;
        var iconContent;
        var contentFirstLine;
        var contentSecondLine;
        var searchDetailID = "full-search-detail-".concat(historyDetail || false);
        if (sanitized) {
            contentFirstLine = React.createElement("span", null, name);
        }
        else {
            contentFirstLine = (React.createElement("div", { className: getClassNameList('truncate') },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: name } })));
            if (subtext) {
                contentSecondLine = (React.createElement("div", { "data-stid": searchDetailID, className: getClassNameList('is-subText', 'truncate'), dangerouslySetInnerHTML: { __html: subtext } }));
            }
        }
        if (icon) {
            iconContent = React.createElement(UitkIcon, { name: icon, size: UitkIconSize.SMALL });
        }
        if (subtext) {
            ariaLabel = "".concat(name, " ").concat(subtext).replace(/(<([^>]+)>)/gi, '');
        }
        else {
            ariaLabel = name === null || name === void 0 ? void 0 : name.replace(/(<([^>]+)>)/gi, '');
        }
        return (React.createElement(UitkActionListItem, { spacing: "relaxed", className: cssClassNames, "data-stid": stid && "".concat(stid, "-result-item"), "data-index": index },
            React.createElement(UitkButton, { "data-stid": stid && "".concat(stid, "-result-item-button"), onClick: this.handleClick, className: getClassNameList(subtext && 'has-subtext', "".concat(stid, "-result-item-button"), 'result-item-button'), "aria-label": ariaLabel, type: "button", isFullWidth: true }),
            React.createElement(UitkLayoutFlex, null,
                React.createElement(UitkLayoutFlexItem, { alignSelf: "center" }, iconContent),
                React.createElement(UitkLayoutFlexItem, null,
                    React.createElement("div", { className: getClassNameList('uitk-typeahead-button-label', 'truncate') },
                        contentFirstLine,
                        contentSecondLine)))));
    };
    UitkTypeaheadResultItem.displayName = 'UitkTypeaheadResultItem';
    return UitkTypeaheadResultItem;
}(React.Component));

export { UitkTypeaheadResultItem };
